import Content from "./Content";

export default Content;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/index.js